<template>
	<section style="overflow-y: auto;height: calc(100vh - 110px);">
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item label="姓名:" label-width="70px">
					<el-input v-model="filters.adminName" size="small"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" v-on:click="getGridData">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="small" @click="addInfo">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="grid_data"  height="calc(100vh - 180px)"  border highlight-current-row v-loading="listLoading" @selection-change="selectGridChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="adminAccount" label="登录名" width="100"></el-table-column>
			<el-table-column prop="adminName" label="姓名" width="150"></el-table-column>
			<el-table-column prop="roleName" label="角色" width="120"></el-table-column>
			<el-table-column prop="adminAddTime" label="建档时间" width="150" :formatter="$util.dateFormatEx"></el-table-column>
			<el-table-column prop="adminLastloginIP" label="登录IP" width="150"></el-table-column>
			<el-table-column prop="adminLastLoginTime" label="登录时间" width="150" :formatter="$util.dateFormatEx"></el-table-column>
			<el-table-column label="操作" min-width="250">
				<template scope="scope">
					<el-button size="small" @click="resetPwd(scope.$index, scope.row)">重置密码</el-button>
					<el-button size="small" @click="editInfo(scope.$index, scope.row)">编辑</el-button>
					<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
			@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>
		
      <addsave :showTitle="showTitle" :dialogAddShow="dialogAddShow"  :mid="mid" @saveCallBack="saveCallBack"  @getVisible="closeDialog"></addsave>
	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
	import addsave from '../admin/eslrecordadd.vue'
	
	export default {
			name:"eslrecordlist",
		components: { addsave,pagination },
		data() {
			return {
				filters: {
					adminName: '',
					rows:10,
					page:1,
				},
				grid_data: [],
				total: 0,
				listLoading: false,
				sels: [],//列表选中列
				showTitle:"",
				dialogAddShow:false,
				mid:0
			}
		},
		methods: {
			handleSizeChange(val) {
				this.filters.rows = val;
				this.getGridData();
			},
			handleCurrentChange(val) {
				this.filters.page = val;
				this.getGridData();
			},
			//获取列表
			getGridData() {
				this.listLoading = true;
				let formData = this.$util.jsonToForm(this.filters);
				this.$axios.post("/backadmin/geteslrecordlist",formData).then(res=>{
					this.listLoading = false;
					this.total=res.data.total;
					this.grid_data=res.data.data;
				});
			},
			//删除
			delInfo: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					let formData=new FormData();
					formData.append("id",row.adminID);
					this.$axios.post("/backadmin/eslrecorddel",formData).then(res=>{
						if (res.data.status == 0) {
							this.$message("删除成功!");
							this.getGridData();
						} else {
							this.$message(res.data.msg);
						}
					});
				});	
			},
			resetPwd: function (index, row) {
				this.$confirm('重置密码后是888888，确认操作吗?', '提示', {
					type: 'warning'
				}).then(() => {
					let formData=new FormData();
					formData.append("id",row.adminID);
					this.$axios.post("/backadmin/eslrecord_resetpwd",formData).then(res=>{
						if (res.data.status == 0) {
							this.$message("重置成功!");
						} else {
							this.$message(res.data.msg);
						}
					});
				});	
			},
			addInfo:function(){
				this.showTitle="新增操作员";
				this.dialogAddShow=true;
				this.mid=0;
			},
			//显示编辑界面
			editInfo: function (index, row) {
				this.showTitle="编辑操作员";
				this.dialogAddShow=true;
				this.mid=row.adminID;
			},
			saveCallBack:function(){
				this.dialogAddShow=false;
				if(this.mid==0){
					this.handleCurrentChange(1);
				}
				else{
					this.getGridData();
				}
			},
			closeDialog:function (bool) {
			  this.dialogAddShow = bool
			},
			selectGridChange: function (sels) {
				this.sels = sels;
			}
		},
		mounted() {
			this.getGridData();
		}
	}

</script>

<style scoped>

</style>
